module.exports = __webpack_public_path__ + "img/EVEN.f864b2a9.png";